var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFire = function SvgFire(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#fire_svg__a)",
    d: "M4.445 5.091c-.071.76-.121 2.105.328 2.678 0 0-.212-1.478 1.682-3.331.763-.747.939-1.762.673-2.523C6.976 1.484 6.7 1.128 6.46.88A.223.223 0 0 1 6.631.5c1.233.055 3.23.398 4.079 2.528.372.935.4 1.901.222 2.883-.112.628-.512 2.023.4 2.194.652.123.967-.395 1.108-.767a.222.222 0 0 1 .373-.07c1.1 1.251 1.193 2.725.966 3.994-.44 2.452-2.924 4.237-5.391 4.237-3.083 0-5.537-1.764-6.173-4.956-.256-1.289-.126-3.839 1.861-5.639.148-.135.39-.015.37.187"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#fire_svg__b)",
    d: "M9.514 9.678c-1.136-1.463-.628-3.132-.349-3.797.038-.087-.062-.17-.141-.116-.489.333-1.49 1.115-1.956 2.216-.632 1.49-.587 2.218-.213 3.108.225.536-.036.65-.167.67-.128.02-.245-.065-.34-.154a2 2 0 0 1-.554-.95c-.02-.077-.121-.099-.168-.035-.35.484-.53 1.26-.54 1.809C5.06 14.125 6.46 15.5 8.156 15.5c2.135 0 3.692-2.362 2.464-4.337-.356-.575-.691-.952-1.106-1.485"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "fire_svg__a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-8.82338 -.03835 .06292 -14.47736 7.777 15.538)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.314,
    stopColor: "#FF9800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.662,
    stopColor: "#FF6D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.972,
    stopColor: "#F44336"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "fire_svg__b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-.09324 9.23158 -6.94746 -.07017 8.273 6.757)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.214,
    stopColor: "#FFF176"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328,
    stopColor: "#FFF27D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487,
    stopColor: "#FFF48F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.672,
    stopColor: "#FFF7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.793,
    stopColor: "#FFF9C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.822,
    stopColor: "#FFF8BD",
    stopOpacity: 0.804
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.863,
    stopColor: "#FFF6AB",
    stopOpacity: 0.529
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFF38D",
    stopOpacity: 0.209
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.941,
    stopColor: "#FFF176",
    stopOpacity: 0
  })))));
};
export default SvgFire;